module.exports = __webpack_public_path__ + "static/tony-06b3452a655f3009539906c8c8610758.jpg";